// extracted by mini-css-extract-plugin
module.exports = {"text_area":"styles_text_area__ay6bm"};